import styles from './PromoGridTable.module.scss';
import PromoTableItem from './item/PromoTableItem';
import { IBonus, IActiveBonus, OVERLAY_CMS_PAGE_SHOW } from '@spinwise/spinwise-core';
import { Trans } from 'react-i18next';
import { t } from 'i18next';
import { useDispatch } from 'react-redux';
import { BaseText, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import { TypographyLibrary } from 'Libraries/typography.library';
import { EPageSlugs } from 'Types/globals';
import { EOverlayContentWidth, POSITIONS } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';

export interface IGridTable {
  bonus: IBonus | IActiveBonus;
  bonus_terms?: string;
}
const PromoGridTable = ({ bonus, bonus_terms = EPageSlugs.SPORT_WELCOME_BONUS_RULES }: IGridTable) => {
  const currency = bonus.currency?.toString();

  const dispatch = useDispatch();

  const openTerms = (slug: string) => {
    dispatch({
      type: OVERLAY_CMS_PAGE_SHOW,
      data: {
        show: true,
        data: {
          slug: slug,
          position: POSITIONS.TOP,
          contentWidth: EOverlayContentWidth.LARGE,
        },
      },
    });
  };

  // if sport -> render differently
  if (bonus?.data?.free_rounds?.game?.provider?.keyword === 'betby') {
    return (
      <div className={styles.promo_bonus_container_open}>
        {bonus?.data?.deposit_min_sum ? (
          <PromoTableItem
            text={t('bonus.min.deposit.label')}
            bonusValue={`${currency}${bonus.data.deposit_min_sum?.toString()}`}
          ></PromoTableItem>
        ) : null}
        <PromoTableItem
          text={t('bonus.wagering.label')}
          bonusValue={t('bonus.no.wagering.requirements.label')}
        ></PromoTableItem>
        <PromoTableItem
          text={t('free.bet.coefficient.label')}
          bonusValue={t('free.bet.coefficient.description')}
        ></PromoTableItem>
        {bonus?.expire_days ? (
          <PromoTableItem
            text={t('bonus.expires.label')}
            bonusValue={
              <Trans components={{ DAYS: bonus.expire_days?.toString() as any }}>{'bonus.expires.in.days'}</Trans>
            }
          ></PromoTableItem>
        ) : null}
        <PromoTableItem
          text={t('bonus.availability.label')}
          bonusValue={t('bonus.availability.description')}
        ></PromoTableItem>
        <PromoTableItem
          text={t('bonus.other.category.label')}
          bonusValue={
            <div className={styles.bonus_terms} onClick={() => openTerms(bonus_terms)}>
              <BaseText
                value={t('bonus.terms.apply.label')}
                color={TypographyLibrary.Base}
                weight={EBaseTextWeight.W400}
              ></BaseText>
            </div>
          }
        ></PromoTableItem>
        <PromoTableItem
          text={t('bonus.other.category.label')}
          bonusValue={
            <div className={styles.bonus_terms} onClick={() => openTerms(EPageSlugs.SPORT_BONUS_TERMS)}>
              <BaseText
                value={t('sport.terms.apply.label')}
                color={TypographyLibrary.Base}
                weight={EBaseTextWeight.W400}
              ></BaseText>
            </div>
          }
        ></PromoTableItem>
      </div>
    );
  }

  return (
    <>
      {bonus && (
        <div className={styles.promo_bonus_container_open}>
          {bonus?.data?.deposit_min_sum ? (
            <PromoTableItem
              text={t('bonus.min.deposit.label')}
              bonusValue={`${currency}${bonus.data.deposit_min_sum?.toString()}`}
            ></PromoTableItem>
          ) : null}

          {bonus?.data?.free_rounds?.game ? (
            <PromoTableItem
              text={t('bonus.game.label')}
              bonusValue={bonus?.data?.free_rounds?.game?.name}
            ></PromoTableItem>
          ) : null}

          {bonus?.data?.free_rounds?.count ? (
            <PromoTableItem text={t('bonus.spins.label')} bonusValue={bonus?.data?.free_rounds?.count}></PromoTableItem>
          ) : null}

          {bonus?.data?.max_bet ? (
            <PromoTableItem
              text={t('bonus.max.bet.label')}
              bonusValue={currency + bonus.data.max_bet?.toString()}
            ></PromoTableItem>
          ) : null}

          {bonus?.data?.bonus_max_sum ? (
            <PromoTableItem
              text={t('bonus.max.bonus.label')}
              bonusValue={`${currency} ${bonus.data?.bonus_max_sum?.toString()}`}
            ></PromoTableItem>
          ) : null}

          {bonus?.expire_days ? (
            <PromoTableItem
              text={t('bonus.expires.label')}
              bonusValue={
                <Trans components={{ DAYS: bonus.expire_days?.toString() as any }}>{'bonus.expires.in.days'}</Trans>
              }
            ></PromoTableItem>
          ) : null}
        </div>
      )}
    </>
  );
};

export default PromoGridTable;
